// DateInputs.js
import React from 'react';
import PropTypes from 'prop-types';
import styles from './TraderDashboard.module.css';

const DateInputs = ({ params, onInputChange }) => (
  <div className={`${styles.gridContainer} ${styles.dateGridContainer}`}>
    <label className={styles.fieldLabel}>Start Date</label>
    <label className={styles.fieldLabel}>End Date</label>
    <input
      type="date"
      name="start_date"
      value={params.start_date}
      onChange={onInputChange}
      className={`${styles.formInput} ${styles.gridInput}`}
      required
    />
    <input
      type="date"
      name="end_date"
      value={params.end_date}
      onChange={onInputChange}
      className={`${styles.formInput} ${styles.gridInput}`}
      required
    />
  </div>
);

DateInputs.propTypes = {
  params: PropTypes.shape({
    start_date: PropTypes.string,
    end_date: PropTypes.string,
  }).isRequired,
  onInputChange: PropTypes.func.isRequired,
};

export default DateInputs;